// Helper for filling arrays with a uniform baseline dataset
export const fill = (func, length = 0) => [...Array.from({ length }, func)];
